<template>
  <Modal :id="'cmp-distribution-account-import-setup'" @cancelled="onCancel">
    <template slot="header">Import Setup {{setupParameter.fix_shop}}</template>

    <template slot="body">
      <div v-if="showNext">
        
        <TextField 
          class="m1" 
          :id="'description'" 
          required 
          v-bind="textFieldConfig" 
          :value="setupParameter.description" 
          :placeholder="$t('description')"
          :showValidationIcons="true"
          :immediateValidation="true"
          @valuechanged="onTextFieldValueChange" 
           @validated="onValidation"
        
        />
       
        <Dropdown 
          :options="invoiceProjectTV" 
          class="m2" 
          :selected="invoiceProjectTV.find((x) => x.value == setupParameter.invoice_project_id)" 
          :placeholder="$t('invoice_project')" 
          v-on:selectedChange="(e) => onDropdownChange('invoice_project_id', e)" 
          box 
          required
          :showValidationIcons="true"
          :immediateValidation="true"
          deselect
          @validated="e => onValidation('invoice_project_id', e)"
      
        />
      
        <Dropdown 
          :options="digitalPhysicalTV" 
          class="m2" 
          :selected="digitalPhysicalTV.find((x)=>x.value==setupParameter.digital_physical)" 
          :placeholder="$t('type_string')" 
          v-on:selectedChange="(e) => onDropdownChange('digital_physical', e)" 
          box
          required
          :showValidationIcons="true"
          :immediateValidation="true"
          deselect
          @validated="e => onValidation('digital_physical', e)" 
       
        
       
        />
    
        
        <Dropdown 
          :options="currencyTV" 
          class="m2" 
          :selected="currencyTV.find((x) => x.value == setupParameter.currency_id)" 
          :placeholder="$t('currency')" 
          v-on:selectedChange="(e) => onDropdownChange('currency_id', e)" 
          box 
          v-if="showControl(['',null,'digital','physical','thirdparty','multi','performance'])"
          required
          :showValidationIcons="true"
          :immediateValidation="true"
          deselect
          @validated="e => onValidation('currency_id', e)" 
        
        />

        <Dropdown 
          :options="statementPeriodTV" 
          class="m2" 
          :selected="statementPeriodTV.find((x) => x.value == setupParameter.statement_period)" 
          :placeholder="$t('period')" 
          v-on:selectedChange="(e) => onDropdownChange('statement_period', e)" 
          box 
          required
          :showValidationIcons="true"
          :immediateValidation="true"
          deselect
          @validated="e => onValidation('statement_period', e)" 
        
        />

        <TextField 
          class="m1" 
          :id="'fix_country'" 
       
          v-bind="textFieldConfig" 
          :value="setupParameter.fix_country" 
          :placeholder="$t('fix_country')" 
        
          @valuechanged="onTextFieldValueChange" 
        
        />

        <div style=" gap:20px;" class="ut-flex">

          <TextField
            style="flex:1;min-width:190px"
            type="date"
            id="start_date"
            class="m1"
            :placeholder="$t('from')"
            :value="setupParameter.start_date"
            @valuechanged="onTextFieldValueChange"
          />
          <TextField
            style="flex:1;min-width:190px"
            type="date"
            id="end_date"
            class="m1"
            :placeholder="$t('to')"
            :value="setupParameter.end_date"
            @valuechanged="onTextFieldValueChange"
          />

        </div>

        <TextField 
          class="m1" 
          :id="'sender'" 
       
          v-bind="textFieldConfig" 
          :value="setupParameter.sender" 
          :placeholder="$t('sender')" 
        
          @valuechanged="onTextFieldValueChange" 
        
        />

        <TextField 
          class="m1" 
          :id="'shared_key'" 
       
          v-bind="textFieldConfig" 
          :value="setupParameter.shared_key" 
          :placeholder="$t('shared_key')" 
        
          @valuechanged="onTextFieldValueChange" 
        
        />

        <Dropdown 
          :options="presetTV" 
          class="m2" 
          :selected="presetTV.find((x) => x.value == setupParameter.statement_preset_id)" 
          :placeholder="$t('preset')" 
          v-on:selectedChange="(e) => onDropdownChange('statement_preset_id', e)" 
          deselect
          box  
        />
        <Dropdown 
          v-if="showControl(['digital','thirdparty','physical','multi','performance'])"
          :options="dssTV" 
          class="m2" 
          :selected="dssTV.find((x) => x.value == setupParameter.dss_id)" 
          :placeholder="$t('dss')" 
          v-on:selectedChange="(e) => onDropdownChange('dss_id', e)" 
          deselect
          box  
        />

        <TextField 
          class="m1" 
          :id="'fix_shop'" 
          v-if="showControl(['digital','multi'])"
          v-bind="textFieldConfig" 
          :value="setupParameter.fix_shop" 
          :placeholder="$t('fix_shop')" 
        
          @valuechanged="onTextFieldValueChange" 
        
        />
        <Dropdown 
           v-if="showControl(['digital','thirdparty','multi',,'performance'])"
          :options="usageTypeTV" 
          class="m2" 
          :selected="usageTypeTV.find((x) => x.value == setupParameter.usage_type_id)" 
          :placeholder="$t('fix_type')" 
          v-on:selectedChange="(e) => onDropdownChange('fix_digital_type', e)" 
          box  
        />

        <TextField 
          class="m1" 
          :id="'return_handling_fee'" 

          :type="'number'"
          v-if="showControl(['physical'])"
          v-bind="textFieldConfig" 
          :value="setupParameter.return_handling_fee" 
          :placeholder="$t('return_handling_fee')" 
        
          @valuechanged="onTextFieldValueChange" 
        
        />

        <div v-if="showControl(['digital','thirdparty','physical','multi','performance'])" style=" gap: 20px;" class="ut-flex">
          <TextField 
            style="flex:1;min-width:190px"
            class="m1" 
            :id="'distribution_fee_sales'" 
            :type="'number'"
            v-bind="textFieldConfig" 
            :value="setupParameter.distribution_fee_sales" 
            :placeholder="$t('distribution_fee')+' Sales'" 
          
            @valuechanged="onTextFieldValueChange" 
          
          />
          <TextField 
            class="m1" 
            style="flex:1;min-width:190px"
            :id="'distribution_fee_returns'" 
            :type="'number'"
            v-bind="textFieldConfig" 
            :value="setupParameter.distribution_fee_returns" 
            :placeholder="$t('distribution_fee')+' Returns'" 
          
            @valuechanged="onTextFieldValueChange" 
          
          />
        </div>


        
      </div>
        

      <ImportSetupModal2 :contact_id_invoice="this.setupParameter.contact_id_invoice||0" @selected="onContactSelect" v-else />

    
    </template>
    <template slot="options">
      
      <button class="dt-button s6" @click="onCancel">Cancel</button>
      <button v-if="showNext" class="dt-button s6 v1"         
        :class="{ disabled: !isFormValid }"
        :disabled="!isFormValid "
        @click="onNext"
      >
        {{ $dft.capHead($t('next'))}}
      </button>
      <button v-if="!showNext" class="dt-button s6"         
        @click="onNext"
      >
        Back
      </button>
      <button v-if="!showNext" class="dt-button s6 v1"         

        @click="onOKClick"
      >
        OK
      </button>
    </template>
  </Modal>
</template>

<script>
import { DistributionStoreNamespace as storeNS } from "../../store";
import { mapActions, mapGetters } from "vuex";
import * as ActionTypes from "../../store/types";
import { Subject } from "rxjs";
import { distinctUntilChanged, debounceTime } from "rxjs/operators";

import InputField from "../../../../plugins/text-field/input-field";
import AddPerson from "../../../../dt-plugins/add-contact-relation/add-person";
import AddCompany from "../../../../dt-plugins/add-contact-relation/add-company";
import { waitForAnimation, subscribeSubject } from "../../../../utility";
import Modal from "../../../../dt-plugins/modal/modal";
import { createModalMixin, closeModal2Route, openModal2Route } from "../../../../dt-plugins/modal/modal.mixin";


import { AccountService } from "../../services/account.service";
import { createTV } from '../../../../models/text-value.model';

import ImportSetupModal2 from './import-setup-modal2.vue';

export default {
  components: {
    InputField,
    AddPerson,
    AddCompany,
    Modal,
    ImportSetupModal2,
  },
  mixins: [],

  data: function () {
    return {
  
      showNext:true,
      setupParameter: {
        account_id: this.$route.query.account_id,
        description: "",
        fix_country:"",
        sender:"",
        shared_key:"",
        end_date:"",
        start_date:"",
        statement_preset_id:'',
        dss_id:"",
        distribution_fee_returns:"",
        distribution_fee_sales:"",
        fix_shop:this.$route.query.account_name,

        return_handling_fee:"",
        fix_digital_type:"",

        digital_physical:"",
        statement_period: '',
        currency_id: '',
        invoice_project_id: '',

        contact_id_invoice:undefined
      },

      formData:{},

      presetArray:[],


      validationResult: {},


    };
  },
  mounted:async function () {
    if(this.mode=='add'){
      await this.getFormData(this.$route.query.account_id,'');
      
    }else if(this.mode=='edit'){
      await this.getFormData(this.$route.query.account_id,this.$route.query.statement_setting_id);
      
      this.setupParameter={...this.formData.stmt_setting}

      const resPresetData = await AccountService.channelPresets(this.setupParameter['digital_physical']);

      this.presetArray =resPresetData.data.presets;
    }
    
  },
  computed: {
    mode:function(){
      return this.$route.query.mode;
    },  
    isFormValid: function() {
      return Object.values(this.validationResult).every(e => e.valid);
    // return ""
    },
    textFieldConfig: function () {
      return {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,

        // immediateValidation : isChromium() ? false : true,
      };
    },
    presetTV:function(){
      return createTV(this.presetArray,'preset_name','statement_preset_id');
    },

    digitalPhysicalTV:function(){
      return [
        { text:'Digital' , value:'digital' },
        { text:'Physical' , value:'physical' },
        { text:'Costs' , value:'costs' },
        { text:'Third Party' , value:'thirdparty' },
        { text:'Performance' , value:'performance' },
        { text:'Other Income' , value:'income' },
        { text:'Multi' , value:'multi' },
      ]
    },

    dssTV:function(){
      return createTV(this.formData?.dss_list,'dss_name','dss_id');
    },
    usageTypeTV:function(){
      return createTV(this.formData?.usage_types,'usage_type_name','usage_type');
    },

    invoiceProjectTV:function(){
      return createTV(this.formData?.invoice_projects,'invoice_project_name','invoice_project_id');
    },

    currencyTV:function(){
      return createTV(this.formData?.currencies,'currency_iso','currency_id');
    },

    statementPeriodTV:function(){
      return [
        { text:'monthly' , value:'monthly' },
        { text:'quaterly' , value:'quaterly' },
        { text:'halfyear' , value:'halfyear' },
        { text:'year' , value:'year' },
     
      ]
    },


  },
  methods: {
    onValidation: function(name, value) {
      this.$set(this.validationResult, name, value);

      if(this.setupParameter.digital_physical=='costs'||this.setupParameter.digital_physical=='income'){
        this.$set(this.validationResult, 'currency_id', { errorMessages: Array [ "Valid" ] , valid: true});
      }
      console.log("this.validationResult,name, value",name ,value);
    },

    getFormData:async function(account_id,statement_setting_id){
      const resFormData = await AccountService.accountStatememntSetupForm1(account_id,statement_setting_id)
      console.log(":::::::::::",this.$route.query);
      this.formData=resFormData.data;
    },

    showControl:function(channelName){
      let flag= false;
      channelName.forEach(e=>{
        if(this.setupParameter['digital_physical']==e){
          flag = true;
        }
      });

      console.log(flag,"::::::::::::",channelName,this.setupParameter['digital_physical'])


      return flag;
    },
    onContactSelect:function(payload){
      const { contact_id } =payload;

      this.setupParameter['contact_id_invoice'] = contact_id;
    },


    onNext:function () {
      this.showNext = !this.showNext;
      this.$emit('setModalSize',this.showNext?'small2':'medium')
    },
    onDropdownChange:async function (name, value) {
      this.setupParameter[name] = value.value;

      if(name=='digital_physical'){
        const resPresetData = await AccountService.channelPresets(value.value);

        this.presetArray =resPresetData.data.presets;
      }

    },
    onTextFieldValueChange: function (key, value) {
      this.setupParameter[key] = value;
    },

    getPayload:function(){
       if(this.setupParameter['digital_physical']=='digital'){

        const  { account_id ,description	, invoice_project_id	, digital_physical	,
            statement_period	, fix_country	, start_date	, end_date	, dss_id	,
            sender	, shared_key	, statement_preset_id	, currency_id	,fix_shop	,fix_digital_type	,
            distribution_fee_sales ,distribution_fee_returns , contact_id_invoice
          } = this.setupParameter;


          return {
                  account_id ,description	, invoice_project_id	, digital_physical	,
                  statement_period	, fix_country	, start_date	, end_date	, dss_id	,
                  sender	, shared_key	, statement_preset_id	, currency_id	,fix_shop	,fix_digital_type	,
                  distribution_fee_sales ,distribution_fee_returns , contact_id_invoice 
                }

      }else if(this.setupParameter['digital_physical']=='physical'){
          const { account_id ,description	,invoice_project_id, digital_physical ,statement_period,
                  fix_country	,start_date	,end_date ,	dss_id ,sender ,shared_key ,statement_preset_id	,
                  currency_id	,return_handling_fee	,distribution_fee_sales,distribution_fee_returns ,contact_id_invoice
                } =this.setupParameter;
        return { account_id ,description	,invoice_project_id, digital_physical ,statement_period,
                  fix_country	,start_date	,end_date ,	dss_id ,sender ,shared_key ,statement_preset_id	,
                  currency_id	,return_handling_fee	,distribution_fee_sales,distribution_fee_returns ,contact_id_invoice
                }

      }else if(this.setupParameter['digital_physical']=='costs'){
        const  {
                    account_id ,  description	, invoice_project_id ,digital_physical , statement_period ,
                    fix_country	,start_date	,end_date	, dss_id	,sender	,shared_key	,statement_preset_id	,
                    contact_id_invoice
                  } = this.setupParameter
        return {
                    account_id ,  description	, invoice_project_id ,digital_physical , statement_period ,
                    fix_country	,start_date	,end_date	, dss_id	,sender	,shared_key	,statement_preset_id	,
                    contact_id_invoice
                  }

      }else if(this.setupParameter['digital_physical']=='thirdparty'){
        const {
                    account_id ,  description	,invoice_project_id ,digital_physical , statement_period ,
                    fix_country	, start_date ,end_date , dss_id ,sender ,shared_key , statement_preset_id	,
                    currency_id	, fix_digital_type ,distribution_fee_sales ,distribution_fee_returns , contact_id_invoice
                  } =this.setupParameter
        return {
                    account_id ,  description	,invoice_project_id ,digital_physical , statement_period ,
                    fix_country	, start_date ,end_date , dss_id ,sender ,shared_key , statement_preset_id	,
                    currency_id	, fix_digital_type ,distribution_fee_sales ,distribution_fee_returns , contact_id_invoice
                  }

      }else if(this.setupParameter['digital_physical']=='performance'){
        const {
                  account_id	, description	, invoice_project_id	, digital_physical	,statement_period	,fix_country	,start_date	,end_date	,
                  dss_id	,sender	, shared_key	, statement_preset_id	, currency_id	,fix_digital_type	, distribution_fee_sales	,distribution_fee_returns , contact_id_invoice
                  } =this.setupParameter
        return {
                  account_id	, description	, invoice_project_id	, digital_physical	,statement_period	,fix_country	,start_date	,end_date	,
                  dss_id	,sender	, shared_key	, statement_preset_id	, currency_id	,fix_digital_type	, distribution_fee_sales	,distribution_fee_returns , contact_id_invoice
                  }

      }else if(this.setupParameter['digital_physical']=='income'){
                const {
                    account_id , description	, invoice_project_id , digital_physical , statement_period , fix_country	,
                    start_date , end_date , dss_id , sender , shared_key	, statement_preset_id	, contact_id_invoice
                  } = this.setupParameter
                return { account_id , description	, invoice_project_id , digital_physical , statement_period , fix_country	,
                    start_date , end_date , dss_id , sender , shared_key	, statement_preset_id	, contact_id_invoice}

      }else if(this.setupParameter['digital_physical']=='multi'){
              const  { account_id , description	, invoice_project_id	,digital_physical	, statement_period	, fix_country	,
                  start_date	, end_date	, dss_id	, sender	, shared_key	, statement_preset_id	, currency_id	,
                  fix_digital_type	, distribution_fee_sales	, distribution_fee_returns	,contact_id_invoice
                } = this.setupParameter

              return  {  account_id , description	, invoice_project_id	,digital_physical	, statement_period	, fix_country	,
                        start_date	, end_date	, dss_id	, sender	, shared_key	, statement_preset_id	, currency_id	,
                        fix_digital_type	, distribution_fee_sales	, distribution_fee_returns	,contact_id_invoice
                      } 
      }
    },

    onOKClick:function(){
      const payload =this.mode=='edit'? {...this.getPayload(),statement_setting_id:this.$route.query.statement_setting_id }:{ ...this.getPayload() };
      //AccountService.newEditStmtSettings(payload);
      this.$emit('insert',payload)
    },

    onCancel: function () {
      this.$emit("cancelled", true);
    },
  },
};
</script>

<style lang="scss">
.cmp-distribution-account-import-setup{
  .dt-modal--body {
  margin-left: 0px;
}


.dt-modal--options {
  //background-color: red;
    display: flex;
  align-items: center;
  justify-content: space-between;
  button {
    &:first-child {
      margin-right: 10px;
    }
    &:last-child {
      margin-left: 0px 10px;
    }
  }
}
}

</style>
